"use strict";
import Vector from "../../../util/vector";
import { Action } from "../actions";
export default function moveComponentReducer(movingComponent = {}, action) {
  switch (action.type) {
    case Action.MOVING_START: {
      const { component, dragPointIndex, mouseVector } = action;
      return {
        guid: component.guid,
        from: mouseVector,
        origDragPoints: component.dragPoints,
        origPosition: new Vector(component.x, component.y),
        origSize: { width: component.width, height: component.height },
        dragPointIndex
      };
    }
    case Action.MOVING_FINISH: {
      return {};
    }
    default:
      return movingComponent;
  }
}
